module.exports = __webpack_public_path__ + "img/2.28e99124.png";